export enum SectionKey {
  CONSENT = "consent",
  IDENTITY_VERIFICATION = "identity-verification",
  PHOTO_VERIFICATION = "photo-verification",
  MOUSE_SIGNATURE = "mouse-signature",
  SUMMARY = "summary",
}
